/**
 * @generated SignedSource<<6f3b6a1b3fd0f54d2babff3afd65c096>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeSuperSplashLivePrimaryContentItemContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "homeSuperSplashLivePrimaryContentItemContent";
};
export type homeSuperSplashLivePrimaryContentItemContent$key = {
  readonly " $data"?: homeSuperSplashLivePrimaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeSuperSplashLivePrimaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeSuperSplashLivePrimaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "5a3846ba985bdddb268d1d8eb036cb26";

export default node;
